import { Box } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const CardContainer = styled(Box)`
  border-radius: 24px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
`;

export const TopSection = styled(Box)`
  position: relative;
  height: 240px;
  width: 100%;
`;

export const BackgroundImage = styled.div<{ backgroundImage?: string }>`
  position: absolute;
  inset: 0;
  z-index: 1;
  background-color: lightgray;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  ${(props) =>
    props.backgroundImage
      ? `background-image: url(${props.backgroundImage});`
      : ""}

  &:after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to right,
      rgba(10, 19, 20, 0.85) 0%,
      rgba(10, 19, 20, 0.4) 40%,
      rgba(10, 19, 20, 0) 70%
    );
  }
`;

export const ContentWrapper = styled(Box)`
  position: relative;
  z-index: 2;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Title = styled(Text)`
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
`;

export const PriceLabel = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  color: #121212;
  text-align: right;
`;

export const PriceValue = styled(Text)`
  font-size: 20px;
  font-weight: 600;
  color: #121212;
  text-align: right;
`;

export const SelectButton = styled.button`
  background: #121212;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: white;
  width: 100%;
  margin-top: 12px;

  &:hover {
    background: #121212;
  }
`;

export const BottomSection = styled(Box)`
  position: relative;
  width: auto;
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 24px;
  border: 1px solid var(--Border-Disabled-grey50, #f5f5f5);
  background: #fff;
  gap: 8px;
  z-index: 5;
  margin-top: -24px;
`;

export const HighlightsTitle = styled(Text)`
  font-size: 20px;
  font-weight: 600;
  color: #040222;
  margin-bottom: 12px;
`;

export const HighlightItem = styled(Text)`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--Neutral-N500, #36354c);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const CircleTickIcon = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  padding: 2px 2.347px 2.347px 2px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SeeHowItWorks = styled(Text)`
  margin-top: 12px;
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
`;

export const PriceContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
`;
